import gql from 'graphql-tag';

export default gql`
  fragment ManualNotificationsItem on ManualNotificationsItem {
    id
    notification_type
    send_at
    segment_ids
    segments {
      id
      title
    }
    created_at
    user_count
    email_count
    entire_company
    message {
      body
      url
    }
    email {
      subject
      body
      format
    }
  }
`;
